import { Delete } from "@mui/icons-material";
import { Alert, Box, Card, Divider, IconButton } from "@mui/material";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import localize from "../../../common/localize";
import { GetDateInDDMMYYYYFormat } from "../../../common/utils";

export default function ResolutionItem({ resolution, onDelete }) {
  return (
    <Card className="w-full flex flex-col gap-2 p-2">
      <Box className="w-full flex-col flex gap-2">
        <Box className="flex gap-2 justify-between w-full">
          <PageTitleSubtitle
            useEventTitleStyle
            useFieldTitleStyle
            title={resolution.Resolution.Name}
            subtitle={`${localize.code}: ${resolution.Resolution.Code}`}
          />

          {onDelete && (
            <IconButton onClick={onDelete}>
              <Delete sx={{ color: "red", width: "16px", height: "16px" }} />
            </IconButton>
          )}
        </Box>

        <Divider />

        <Box className="flex w-full">
          <Box className="two_columns_grid">
            {resolution.AssignmentDate && (
              <label className="text-xs">
                <b>{localize.assignment_date}: </b>
              </label>
            )}
            {resolution.AssignmentDate && (
              <label className="text-xs">
                {GetDateInDDMMYYYYFormat(new Date(resolution.AssignmentDate))}
              </label>
            )}
            <label className="text-xs">
              <b>{localize.modified_by}:</b>
            </label>
            <label className="text-xs">{resolution.Resolution.CreatedBy}</label>
          </Box>
        </Box>

        {resolution.Resolution.Description && (
          <Alert severity="info" className="w-full">
            <label className="text-xs">
              <b>{localize.description}: </b>
              {resolution.Resolution.Description}
            </label>
          </Alert>
        )}
      </Box>
    </Card>
  );
}
